import React, { useEffect, useRef } from 'react';
import '../BillingStyle/BillingMain.css';

const features = [
  {
    icon: 'bi-sliders',
    accent: '#3B82F6',
    title: 'Flexible Pricing & Packaging',
    description: 'Easily design, deploy, and iterate on pricing and packaging to stay competitive in any market.',
  },
  {
    icon: 'bi-arrow-repeat',
    accent: '#06B6D4',
    title: 'Subscription & Milestone Billing',
    description: 'Meet changing market demands with recurring billing for any business model — subscriptions, milestones, or hybrid.',
  },
  {
    icon: 'bi-graph-up-arrow',
    accent: '#6366F1',
    title: 'Usage Metering & Billing',
    description: 'Capture, consolidate, and monetize consumption data all in one unified solution.',
  },
  {
    icon: 'bi-file-earmark-text',
    accent: '#22C55E',
    title: 'E-Invoicing & Tax Compliance',
    description: 'Ensure GST, TDS, and e-invoicing compliance with pre-built integrations and automated calculations.',
  },
  {
    icon: 'bi-globe2',
    accent: '#F59E0B',
    title: 'Global Payments Orchestration',
    description: 'Optimize payment success and scale globally across 40+ pre-built payment gateway integrations.',
  },
  {
    icon: 'bi-lightning-charge-fill',
    accent: '#EC4899',
    title: 'API-First & Built to Scale',
    description: 'Scale transactions as your business grows without any performance impact — built on a robust API-first architecture.',
  },
];

const Billingchoose = () => {
  const cardRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );
    cardRefs.current.forEach(el => el && observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section className="bill-features-section">
      <div className="bill-features-inner">
        <div className="bill-features-header">
          <div className="section-eyebrow">
            <span>Why Choose Us</span>
          </div>
          <h2 className="bill-features-title">
            Why Choose{' '}
            <span style={{
              background: 'linear-gradient(135deg, #60A5FA, #22D3EE)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
            }}>
              BITS Billing?
            </span>
          </h2>
          <p className="bill-features-sub">
            A complete billing ecosystem built for modern Indian businesses — accurate, automated, and always compliant.
          </p>
        </div>

        <div className="bill-features-grid">
          {features.map((f, i) => (
            <div
              key={i}
              className="bill-feature-card"
              ref={el => cardRefs.current[i] = el}
              style={{ '--bf-accent': f.accent, transitionDelay: `${i * 0.08}s` }}
            >
              <div
                className="bill-feature-icon"
                style={{ background: `${f.accent}18`, color: f.accent }}
              >
                <i className={`bi ${f.icon}`}></i>
              </div>
              <h3 className="bill-feature-title">{f.title}</h3>
              <p className="bill-feature-desc">{f.description}</p>
              <div className="bill-feature-bar"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Billingchoose;
